import React, { useEffect, useState } from 'react';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import './viewer.css'

const TranslatedDocFileViewer = ({ fileUrl }) => {
    const [docs, setDocs] = useState([]);

    useEffect(() => {
        console.log("fileUrl prop: ", fileUrl);
        if (fileUrl) {
            setDocs([{ uri: fileUrl }]);
        }
    }, [fileUrl]);

    return (
        <div className=" " style={{ height: '100%' }}>
            {docs.length > 0 ? (
                <DocViewer documents={docs} pluginRenderers={DocViewerRenderers}  />
            ) : (
                <p>Loading document...</p>
            )}
        </div>
    );
}

export default TranslatedDocFileViewer;



// import React, { useEffect, useState } from 'react';
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
// import './viewer.css';

// const TranslatedDocFileViewer = ({ fileUrl }) => {
//     const [docs, setDocs] = useState([]);

//     useEffect(() => {
//         console.log("fileUrl prop: ", fileUrl);
//         if (fileUrl) {
//             setDocs([{ uri: fileUrl }]);
//         }
//     }, [fileUrl]);

//     return (
//         <div className="overflow-hidden mx-5 py-4" style={{ height: '40rem' }}>
//             {docs.length > 0 ? (
//                 <DocViewer documents={docs} pluginRenderers={DocViewerRenderers} />
//             ) : (
//                 <p>Loading document...</p>
//             )}
//         </div>
//     );
// }

// export default TranslatedDocFileViewer;